var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { AbstractRepository } from 'packages/core/AbstractRepository';
import ENV from 'config/env';
import { ExportSystem, } from 'packages/candidate_export/entities/ExportSystem';
import { EntityBuilder } from '@decahedron/entity';
import { ExportJob } from 'packages/candidate_export/entities/ExportJob';
import isNil from 'common/support/isNil';
import { DataSubProcessorConsent } from 'packages/candidate_export/entities/DataSubProcessorConsent';
import { KomboRecruitmentAssociation, } from 'packages/candidate_export/entities/KomboRecruitmentAssociation';
var CandidateExportRepository = /** @class */ (function (_super) {
    __extends(CandidateExportRepository, _super);
    function CandidateExportRepository() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.url = 'ats-integrations/v1';
        _this.entity = null;
        _this.baseUrl = ENV.JOBILLA_API_ROOT;
        return _this;
    }
    CandidateExportRepository.prototype.getConsents = function (companyId) {
        return this.get(this.url + "/company/" + companyId + "/data-sub-processor-consent")
            .then(function (response) { var _a, _b; return EntityBuilder.buildMany(DataSubProcessorConsent, (_b = (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.consents) !== null && _b !== void 0 ? _b : []); });
    };
    CandidateExportRepository.prototype.storeConsent = function (companyId, payload) {
        return this.post(this.url + "/company/" + companyId + "/data-sub-processor-consent", payload);
    };
    CandidateExportRepository.prototype.linkKomboRecruitment = function (jobId, payload) {
        return this.axios.put(this.url + "/jobs/" + jobId + "/recruitment-association", payload);
    };
    CandidateExportRepository.prototype.getKomboRecruitmentAssociations = function (jobId) {
        return this.get(this.url + "/jobs/" + jobId + "/recruitment-association").then(function (response) { return EntityBuilder.buildOne(KomboRecruitmentAssociation, response.data.association); });
    };
    CandidateExportRepository.prototype.listIntegrationSystems = function (companyId) {
        return this.get(this.url + "/company/" + companyId + "/integrations")
            .then(function (response) {
            if (!response.data.integrations) {
                return [];
            }
            return EntityBuilder.buildMany(ExportSystem, response.data.integrations);
        });
    };
    CandidateExportRepository.prototype.listJobs = function (payload) {
        return this.get(this.url + "/company/:companyId/tool/:toolId/jobs", payload.params, payload.query)
            .then(function (response) {
            var _a, _b;
            return ({
                jobs: EntityBuilder.buildMany(ExportJob, (_a = response.data.jobs) !== null && _a !== void 0 ? _a : []),
                nextCursor: (_b = response.data.next) !== null && _b !== void 0 ? _b : null,
            });
        });
    };
    CandidateExportRepository.prototype.exportCandidates = function (payload) {
        return this.post(this.url + "/export-candidates", {
            tool_id: payload.integrationSystemId,
            jobilla_job_id: payload.jobId,
            external_job_id: payload.externalJobId,
            candidates: payload.candidatesIds,
        });
    };
    CandidateExportRepository.prototype.getKomboLink = function (companyId) {
        return this.post(this.url + "/integrations/kombo/init", {
            company_id: companyId.toString(),
            category: 'ATS',
        })
            .then(function (response) {
            if (isNil(response === null || response === void 0 ? void 0 : response.link)) {
                return '';
            }
            return response.link;
        });
    };
    CandidateExportRepository.prototype.activateKomboIntegration = function (komboConnectToken) {
        return this.post(this.url + "/integrations/kombo/activate", { token: komboConnectToken });
    };
    return CandidateExportRepository;
}(AbstractRepository));
export { CandidateExportRepository };
